import { render } from "./ContractItem.vue?vue&type=template&id=1c596654&scoped=true"
import script from "./ContractItem.vue?vue&type=script&lang=js"
export * from "./ContractItem.vue?vue&type=script&lang=js"

import "./ContractItem.vue?vue&type=style&index=0&id=1c596654&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c596654"

export default script